import React from 'react'
import CMPService from '../../cmp/CMPService'
import lock from '../../genericComponents/assets/lock.svg'
import T from '../../i18n/T'
import SVGIcon from '../../svg/SVGIcon'
import useEventCallback from '../../utils/useEventCallback'
import s from './FooterPrivacy.less'

const FooterPrivacy = () => {
  const onPrivacyOpen = useEventCallback(() => CMPService.open())

  return (
    <div id="FooterPrivacy" className={s.FooterPrivacy}>
      <SVGIcon url={lock} className="ssrFooterImg" />
      <span className={s.FooterPrivacyLink} onClick={onPrivacyOpen}>
        <T id={'footer.privacy'} />
      </span>
      {' | '}
      <a className={s.FooterPrivacyLink} href="/consentement-audience">
        <T id={'footer.privacy.analytics'} />
      </a>
      {' | '}
      <a
        className={s.FooterPrivacyLink}
        target="_blank"
        href="https://blog.mappy.com/gerer-utiq"
        rel="nofollow noopener noreferrer"
      >
        <T id={'footer.privacy.utiq'} />
      </a>
    </div>
  )
}

export default FooterPrivacy
